import Navbar from "./Componant/Navbar";
import ProductList from "./Componant/ProductList";
import Slider from "./Componant/Slider";
import { Routes, Route } from "react-router-dom";
import About from "./Componant/About";
import ProductDetails from "./Componant/ProductDetails"

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={
            <>
              <Slider />
              <ProductList />
            </>
          }
        />
        <Route path="About" element={<About />} />
        <Route path="product/:productId" element={<ProductDetails />} />
      </Routes>
    </div>
  );
}

export default App;
